import { createSearchParams, useSearchParams } from 'react-router';

/**
 * @param tab The tab to navigate to
 * @returns A function to navigate to the specified tab
 */
export const useNavigateToTab = <T extends string>(tab: T) => {
  const [, setSearchParams] = useSearchParams();

  return () => {
    setSearchParams(createSearchParams({ tab }));
  };
};
